module.exports = __webpack_public_path__ + "static/saintlary-1d24f8cb75bb98b067372983c9c57444.png";